<template lang="pug">
.progress
  .progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" v-bind:aria-valuenow="value" v-bind:aria-valuemin="min" v-bind:aria-valuemax="max" v-bind:style="style")
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    min: {
      type: [Number, String],
      default: 0,
    },
    max: {
      type: [Number, String],
      default: 1.0,
    },
  },
  computed: {
    percentage() {
      let p = (parseFloat(this.value) - parseFloat(this.min)) / (parseFloat(this.max) - parseFloat(this.min)) * 100;
      if (p < 0) p = 0;
      if (p > 100) p = 100;
      return p;
    },
    style() {
      return `width: ${this.percentage}%`;
    },
  }
}
</script>